import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MixpanelService {
  private isInitialized = false;

  constructor() {
    this.init();
  }

  private init(): void {
    if (!this.isInitialized) {
      mixpanel.init('84d0b73c9a8cd5801f927812c28619ed', {
        autocapture: true,
        record_sessions_percent: 100,
      });
      this.isInitialized = true;
    }
  }

  track(eventName: string, properties?: any): void {
    if (this.isInitialized) {
      mixpanel.track(eventName, properties);
    }
  }

  identify(userId: string): void {
    if (this.isInitialized) {
      mixpanel.identify(userId);
    }
  }

  setUserProperties(properties: any): void {
    if (this.isInitialized) {
      mixpanel.people.set(properties);
    }
  }

  alias(newId: string): void {
    if (this.isInitialized) {
      mixpanel.alias(newId);
    }
  }

  reset(): void {
    if (this.isInitialized) {
      mixpanel.reset();
    }
  }

  timeEvent(eventName: string): void {
    if (this.isInitialized) {
      mixpanel.time_event(eventName);
    }
  }
}
